
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SiteModel } from './Distribution.Api.Models.Site';
import { Model, ModelProperty } from 'models/Model';


export class PointerModel extends Model<PointerModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'primaryPointer', type: 'boolean' },
		{ name: 'status', type: 'PointerStatus' },
		{ name: 'taskId', type: 'string' },
		{ name: 'site', type: 'SiteModel', isHidden: true, isObject: true, new: () => { return new SiteModel }, properties: () => { return SiteModel.classProperties } },
		{ name: 'siteId', type: 'string' },
		{ name: 'message', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public primaryPointer: boolean;
	public status: PointerStatus;
	public taskId: string;
	public site?: SiteModel;
	public siteId?: string;
	public message: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.primaryPointer = false;
		this.status = 0;
		this.taskId = '';
		this.site = undefined;
		this.siteId = undefined;
		this.message = '';
		
	}
	getProperties(){
		return PointerModel.classProperties;
	}
}

export enum PointerStatus{
	InProgress = 0,
	Completed = 1,
	Failed = 2,
	InProgressForDeletion = 3,
	FailedToDelete = 4
}
export namespace PointerStatus {
	export function getKeys(): Map<PointerStatus, string> {
		return new Map([[0, 'InProgress'], [1, 'Completed'], [2, 'Failed'], [3, 'InProgressForDeletion'], [4, 'FailedToDelete']]);
	}
}
